import axios from 'axios';
import { baseUrl, load } from '../Pages/ApiCommonService';
import { expTokenProcessAndGenerate } from './AuthApis';

const token = sessionStorage.getItem('token');
// -----------------****Api Calls for fetch Dashboard Counts (jobSummarycount, jobDataChartscount)****-------------//

export const fetchJobSummaryCnt = async (token: any) => {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    try {
        const response = await axios.get(`${baseUrl}api/dashboard/GetDashboardData`, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response.data;
        }
        throw new Error(`Unexpected response status: ${response.status}`);
    } catch (error: any) {
        if (error?.response?.status === 401) {
            load.reload()
            await expTokenProcessAndGenerate(sessionStorage.getItem('token'));
        }
        console.error('Error fetching summary_count:', error);
        throw error;
    }
};

export const fetchChartCount = async (token: any) => {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    try {
        const response = await axios.get(baseUrl + 'api/dashboard/GetJobsCountBarChart', {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response
        }
    } catch (error: any) {
        if (error?.response?.status === 401) {
            load.reload()
            await expTokenProcessAndGenerate(sessionStorage.getItem('token'));
        }
        console.error('Error fetching lineOrbarchart_count:', error);
    }
};

export const fetchWeeklyChartCount = async (token: any) => {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    try {
        const response = await axios.get(baseUrl + 'api/dashboard/GetJobsCountBarChartWeekly', {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response;
        }
    } catch (error: any) {
        console.error('Error fetching weekly chart count:', error);
    }
};


export const fetchDataCsrDashboard = async (from_date: string, to_date: string, client_name: string,
    policy_no: string, line_of_covege: string, policy_type: string, job_id: string, pageNo: number, pageSize: number) => {

    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams();

        params.append('from_date', from_date);
        params.append('to_date', to_date);
        params.append('pageNo', pageNo.toString());
        params.append('pageSize', pageSize.toString());
        params.append('isExport', 'false');

        if (client_name) params.append('client_name', client_name);
        if (policy_no) params.append('policy_no', policy_no);
        if (line_of_covege) params.append('line_of_covege', line_of_covege);
        if (policy_type) params.append('policy_type', policy_type);
        if (job_id) params.append('job_id', job_id);

        const url = `${baseUrl}api/dashboard/GetcsrDatabyDateWise?${params.toString()}`;

        const response = await axios.get(url, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response
        }
    } catch (error: any) {
        if (error?.response?.status === 401) {
            load.reload()
            await expTokenProcessAndGenerate(sessionStorage.getItem('token'));
        }
        console.error('Error fetching lineOrbarchart_count:', error);
    }
};

export const generateExportExcelforCsrRole = async (fromDate: any, toDate: any, client_name: string, policy_no: string, 
    line_of_covege: string, policy_type: string, jobId: string) => {   //Api call for exportExcel csr_roleDashboard
    
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        let url = `${baseUrl}api/dashboard/ExportForCsrDashboard?from_date=${fromDate}&to_date=${toDate}`;

        if (client_name) {
            url += `&client_name=${client_name}`;
        }

        if (policy_no) {
            url += `&policy_no=${policy_no}`;
        }

        if (line_of_covege) {
            url += `&line_of_covege=${line_of_covege}`;
        }

        if (policy_type) {
            url += `&policy_type=${policy_type}`;
        }

        if (jobId) {
            url += `&job_id=${jobId}`;
        }

        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error in downloading csrRoleExportData:', error);
        throw error;
    }
};

// ----------------------------------------------------------------------------------------------------------------//

export const statuses = [
    { color: "#007bff", label: "InProgress Jobs" },
    { color: "#28a745", label: "Success Jobs" },
    { color: "#808080", label: "Dispatch Jobs" },
    { color: "#dc3545", label: "Dispatch Failed Jobs" },
];
